import React from 'react';

import { Tooltip, Status as UIStatus } from '@gogame/components';

import {
  STATUS_ACTIVE,
  STATUS_DRAFT,
  STATUS_INACTIVE,
  STATUS_IN_TEST,
} from './constants';

export const getColor = (name) => {
  switch (name) {
    case STATUS_INACTIVE:
      return 'inactive';
    case STATUS_DRAFT:
      return 'draft';
    case STATUS_ACTIVE:
      return 'success';
    case STATUS_IN_TEST:
      return 'info';
  }
};

const Status = ({ id, isSapSynced }) => {
  let color = getColor(id, isSapSynced);
  if ([STATUS_ACTIVE, STATUS_IN_TEST].includes(id) && !isSapSynced) {
    color = 'error';
    return (
      <Tooltip title={'Sync error'} wrapper>
        <UIStatus color={color}>{id}</UIStatus>
      </Tooltip>
    );
  }

  return <UIStatus color={color}>{id}</UIStatus>;
};

export default Status;
